import React from "react";
import PropTypes from "prop-types";
import style from "./CenterSelector.module.sass";

function CenterSelector(props) {
  const {
    centers,
    currentCenterId,
    centerSelectionURL,
    csrfToken,
  } = props;

  const onCenterChange = (e) => {
    e.target.form.submit();
  };

  return (
    <form
      action={centerSelectionURL}
      method="post"
      className={style.centerForm}
    >
      <input
        type="hidden"
        name="authenticity_token"
        value={csrfToken}
      />

      <select
        name="center_id"
        value={currentCenterId || ""}
        onChange={onCenterChange}
        className={style.centerSelect}
      >
        {!currentCenterId && (
          <option value="" disabled>
            Seleziona un centro
          </option>
        )}

        {centers.map((center) => (
          <option key={center.id} value={center.id}>
            {center.name}
          </option>
        ))}
      </select>
    </form>
  );
}

CenterSelector.propTypes = {
  centers: PropTypes.array.isRequired,
  currentCenterId: PropTypes.number,
  centerSelectionURL: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
};

CenterSelector.defaultProps = {
  currentCenterId: null,
};

export default CenterSelector;